module.exports = __webpack_public_path__ + "img/deloitte-logo.096bc6b9.svg";